import React, {useEffect, useState} from 'react';

export default ({props, onLoad, isLoading = true}) => {
  const [component, setComponent] = useState({module: null});
  const DynamicComponent = component.module;

  useEffect(() => {
    if (isLoading) {
      onLoad()
        .then(module => {
          setComponent({module: module.default});
        });
    }
  }, []);
  return DynamicComponent && <DynamicComponent {...props} />;
};
